<template>
  <div class="dashboard">
	<div>
    <div class="dyn-form mt-5">
      <b-alert :variant="actionState.alert.variant" :show="actionState.alert.visible" :class="{ 'mb-5': !actionState.alertError.visible}" class="d-flex flex-wrap-0 align-items-center justify-content-start pt-3 pb-2">
      <div class="flex-grow-0 pl-0 pr-4">
        <b-icon :icon="actionState.alert.icon" :variant="actionState.alert.variant" class="left-alert-icon" />
      </div>
      <div class="flex-grow-1 mb-1"><span v-html="actionState.alert.text"></span><span v-if="actionState.alert.retryLink"><br/><a class="cursor-pointer" @click="states.mainPage=!states.mainPage;states.verifPages=!states.verifPages">Zmeniť údaje na overenie</a></span></div>
    </b-alert>
<!-- ERROR ALERT ONLY -->
    <b-alert :variant="actionState.alertError.variant" :show="actionState.alertError.visible" class="d-flex flex-wrap-0 align-items-center justify-content-start pt-3 pb-2 mb-5">
      <div class="flex-grow-0 pl-0 pr-4">
        <b-icon :icon="actionState.alertError.icon" :variant="actionState.alertError.variant" class="left-alert-icon" />
      </div>
      <div class="flex-grow-1 mb-1"><span v-html="actionState.alertError.text"></span><span v-if="actionState.alertError.retryLink"><br/><a class="cursor-pointer" @click="states.mainPage=!states.mainPage;states.verifPages=!states.verifPages">Zmeniť údaje na overenie</a></span></div>
    </b-alert>
<!--  -->
    <div v-if="isVerified">
      <div v-if="states.mainScenario === 'b2b'">
        <div class="lh-22">
          <p class="font-weight-bold mb-0">Spoločnosť</p>
          <p class="my-0" v-html="verifData.data.companyName" />
          <span>IČO: {{ verifData.data.registrationNumber }}</span>

          <p class="font-weight-bold mb-0 mt-4">Primárna kontaktná osoba</p>
          <span><span v-show="verifData.data.firstname">{{ verifData.data.firstname }} </span>{{ verifData.data.lastname }}</span>
          <p class="mb-0" v-if="verifData.data.foreignId.value">Identifikačný doklad: {{ verifData.data.foreignId.name }} {{ verifData.data.foreignId.value }}</p>
        </div>
        <h2 class="mt-5">Údaje, ktoré je možné upraviť:</h2>        
        <div v-show="verifData.data.idCard !== null">
          <div class="form-group position-relative mb-5 mt-4">
            <label class="inner-label">Číslo občianskeho preukazu</label>
            <input type="text" class="form-control" :class="{ 'res_error': errors.idCard.visible }" v-model="newData.idCard" @keyup="checkChange('idCard')" :disabled="submitDisabled">
            <span class="error_message text-muted position-absolute" v-show="errors.idCard.visible"><small v-text="errors.idCard.text" /></span>
          </div>

          <div class="form-group position-relative my-5">
            <label class="inner-label">Rodné číslo</label>
            <input type="text" class="form-control" :class="{ 'res_error': errors.personalNr.visible }" v-model="newData.personalNr">
            <span class="error_message text-muted position-absolute" v-if="errors.personalNr.visible && errors.personalNr.text"><small v-text="errors.personalNr.text" /></span>
            <small class="text-muted ml-1 position-absolute outer-label" v-else>Slúži výhradne pre účel overenia občianskeho preukazu</small>
          </div>
        </div>          
      </div>
      <h2 v-else class="mt-5">Údaje, ktoré je možné upraviť:</h2>        
      <div class="form-group position-relative my-5">
        <label class="inner-label">Telefónne číslo</label>
        <input type="text" class="form-control" :class="{ 'res_error': errors.mobilePhone.visible }" v-model="newData.mobilePhone" @keyup="checkChange('mobilePhone')" :disabled="submitDisabled">
        <span class="error_message text-muted position-absolute" v-show="errors.mobilePhone.visible"><small v-text="errors.mobilePhone.text" /></span>
      </div>
      <div class="form-group position-relative my-5">
        <label class="inner-label">E-mail</label>
        <input type="text" class="form-control" :class="{ 'res_error': errors.email.visible }" v-model="newData.email" @keyup.enter="sendData" @keyup="checkChange('email')" :disabled="submitDisabled">
        <span class="error_message text-muted position-absolute" v-show="errors.email.visible"><small v-text="errors.email.text" /></span>        
      </div>

      <p class="mt-5 mb-3"><a href="/wiki/ostatne/osobne-udaje" target="disc" class="font-weight-bold">Informácie o spracúvaní vašich osobných údajov</a></p>
      <b-button variant="primary" size="lg" :disabled="submitDisabled || actionState.submitDisable" block class="text-uppercase" @click="sendData"><span v-html="sendText" /></b-button>

    </div>
    <!-- <p v-show="retryLink" class="mt-4 mb-0 ml-1"> <a class="link" v-on:click="states.mainPage=!states.mainPage;states.verifPages=!states.verifPages" style="cursor:pointer">Zmeniť údaje na overenie</a></p> -->
  </div>
	</div>
  </div>
</template>

<script>
import validatePersonalNr from '@/components/common'
export default {
  name: 'Actions',
  props: ['states', 'verifData'],
  data() {
    return {
    infoAlert: false, formIntro: "", retryLink: false, isVerified: false, TYClass: 'result', TYText: '&nbsp;', dataOk: false, submitError: "&nbsp;", emailInvalid: false, mobilePhoneInvalid: false, submitDisabled: false,
    newData: { mobilePhone: "", email: "", idCard: "", personalNr: "", view: false, checkOnly: true, setIdCard: false, channelsIntact: true },
    actionState: { alert: { visible: false, text: '', variant: 'success', icon: 'check-circle-fill', retryLink: false }, alertError: { visible: false, text: '', variant: 'danger', icon: 'x-circle-fill', retryLink: false }, submitDisable: false, setIdCard: false, channelsIntact: true },
    errors: { mobilePhone: { text: '', visible: false }, email: { text: '', visible: false }, idCard: { text: '', visible: false }, personalNr: { visible: false, text: '' }}
    }
  },
  mounted: function() {
    this.isVerified = true
    this.submitDisabled = false;
    this.retryLink = false;
    this.actionState.alert.visible = false;
    this.actionState.alertError.visible = false;

    if (this.verifData.data.email !== undefined) {
      this.newData.email = this.verifData.data.email.replace(/ /g, '').toLowerCase();
    }
    if (this.verifData.data.mobilePhone !== undefined) {
      this.newData.mobilePhone = String(this.verifData.data.mobilePhone).replace(/ /g, '');
    }

    if (this.states.mainScenario === 'b2b') {
      if (this.verifData.data.idCard !== undefined && this.verifData.data.idCard !== null) {
        this.newData.idCard = String(this.verifData.data.idCard).replace(/ /g, '');
      } else {
        this.newData.idCard = "";
      }
    }
  },
  created: function() {
    var that = this
    window.history.pushState(null, '')
    window.onpopstate = function() {
    window.history.replaceState(null, '')
	  $('.masterTooltip').tooltip()
      that.states.verifPages = true
      that.states.mainPage = false
    }    
  },
  methods: {
    checkChange: function(elm) {
      const listToCheck = this.states.mainScenario === 'b2b' ? ['mobilePhone', 'email', 'idCard'] : ['mobilePhone', 'email'];
      const that = this;
      if (_.indexOf(listToCheck, elm) !== -1) {
        let res = true;
        _.each(listToCheck, function(vk) {
          if (res){
            res = that.verifData.data[vk] == that.newData[vk];
          }
        })
        if (elm === 'idCard') {
          this.actionState.setIdCard = this.verifData.data[elm] != (String(this.newData[elm])).trim().replace(/ /g, '');
        } else {
          this.actionState.channelsIntact = (this.verifData.data['email'] == (String(this.newData['email'])).trim().replace(/ /g, '') && this.verifData.data['mobilePhone'] == (String(this.newData['mobilePhone'])).trim().replace(/ /g, ''))
        }
        this.newData.checkOnly = res;
      }
    },
    sendData: function() {
    if (!this.submitDisabled && !this.actionState.submitDisable) {      
      var that = this;
      var formOk = true
      this.emailInvalid = false
      this.mobilePhoneInvalid = false
      this.errors = { mobilePhone: { text: '', visible: false }, email: { text: '', visible: false }, idCard: { text: '', visible: false }, personalNr: { visible: false } }
      this.actionState.alert = { visible: false, text: 'Overenie údajov prebehlo úspešne.', variant: 'success', icon: 'check-circle-fill', retryLink: true } 
      this.actionState.alertError.visible = false; 
      this.actionState.alertError.retryLink = false; 
      this.actionState.alertError.text = "";
      this.newData.mobilePhone = this.newData.mobilePhone.toString().replace(/ /g, '')
      if ((!this.checkMailVal(this.newData.email.replace(/ /g, ''))) || (this.newData.email.replace(/ /g, '').length < 5 && (this.verifData.data.email || '').length > 5)) {
        formOk = false
        this.emailInvalid = true
        this.errors.email.visible = true;
        this.errors.email.text = "E-mail nie je správne vyplnený";
      }
      if ((((this.newData.mobilePhone.length < 9) || (isNaN(this.newData.mobilePhone))) && (this.newData.mobilePhone.length != 0)) || (this.newData.mobilePhone.length === 0 && (this.verifData.data.mobilePhone || '').length > 8) || (!this.validateMsisdn(this.newData.mobilePhone))){
        formOk = false
        this.mobilePhoneInvalid = true
        this.errors.mobilePhone.visible = true;
        this.errors.mobilePhone.text = "Telefónne číslo nie je správne vyplnené";
      }
      if (this.states.mainScenario === 'b2b') {
        if (this.verifData.data.idCard !== undefined && this.verifData.data.idCard !== null && ((((this.verifData.data.idCard || '').length > 4 && (this.newData.idCard).length === 0) || (this.newData.idCard).length < 7) && (this.newData.personalNr).length > 8)) {
          formOk = false;
          this.errors.idCard.visible = true;
          this.errors.idCard.text = "Číslo OP nie je správne vyplnené";
        }
        const validationObj = validatePersonalNr(this.newData.personalNr);
        if ((!validationObj.res && !validationObj.isEmpty) && (this.newData.idCard).length !== 0 && (this.newData.idCard != this.verifData.data.idCard)) {
          formOk = false;
          this.errors.personalNr.visible = true;
        } else {
          this.newData.personalNr = validationObj.virgin;        
        }
      }
      if (formOk) {
        if (!this.verifData.data.email) { this.verifData.data.email = '' }
        if (!this.verifData.data.mobilePhone) { this.verifData.data.mobilePhone = '' }
        this.newData.email = this.newData.email.replace(/ /g, '').toLowerCase();
        this.newData.setIdCard = this.actionState.setIdCard;
        this.newData.channelsIntact = this.actionState.channelsIntact;
        this.states.showMain = false;
        _.assign(this.newData, { customerCode: this.verifData.data.customerCode.toString(), bpn: this.verifData.bpn, crlData: this.verifData.data.crlData, scenario: this.verifData.data.scenario, contactId: (this.verifData.data.contactId || '-1') })

        this.$http.post(that.$store.state.validateCustSrc + "/confirm", that.newData)     
        .then(function(resp){
          that.newData.view = !that.newData.view;
          that.dataOk = true
          that.submitDisabled = true;
          let retryLink = true;
          var TYText = "Požiadavka na zmenu Vašich údajov prebehla úspešne.";
          that.actionState.alertError.text = "Požiadavka na zmenu čísla občianskeho preukazu bola zamietnutá z dôvodu nezhody údajov.";            
          if (that.states.mainScenario === 'b2b') {
            try {
              // checkOnly: true/false
              // channelsIntact: true/false
              // setIdCard: true/false
              // newIdAccepted: true/false
              if (resp.data.checkOnly) {
                TYText = "Ďakujeme za potvrdenie správnosti Vašich údajov.";                
              } else if (resp.data.setIdCard && !resp.data.newIdAccepted && resp.data.channelsIntact) {
                TYText = "Ďakujeme za potvrdenie správnosti Vašich kontaktných údajov.";  
                that.actionState.alertError.visible = true;
                that.actionState.alertError.retryLink = true;
                retryLink = false;
              } else if (resp.data.setIdCard && !resp.data.newIdAccepted) {
                that.actionState.alertError.visible = true;
                that.actionState.alertError.retryLink = true;
                retryLink = false;
              }
            } catch(e) {}
          }
          if (that.newData.checkOnly && that.states.mainScenario === 'b2c') {
            TYText = "Ďakujeme za potvrdenie správnosti Vašich údajov.";
          }
          that.actionState.alert = { visible: true, text: TYText, variant: 'success', icon: 'check-circle-fill', retryLink } 
          if (that.newData.mobilePhone.length === 0) {
            that.newData.mobilePhone = that.verifData.data.mobilePhone;       
          }
        })
        .catch(function(err) {
          var TYText = "CHYBA SPRACOVANIA.";
          switch((err.response || {}).status) {
            case 429:
            TYText = "Aktivovala sa ochrana systému. Skúste znovu po uplynutí 15 minút."
              break;
            case 400:
            TYText = "Niektorý z údajov nemá správny formát."
              break;
            case 404:
            TYText = "Prijatá požiadavka nie je platná."
              break;
            default:
            TYText = "CHYBA SPRACOVANIA."
          } 
          that.actionState.alert = { visible: true, text: TYText, variant: 'warning', icon: 'exclamation-circle-fill', retryLink: false } 
          that.submitDisabled = false;
        })
        .finally(function(){
          that.states.showMain = true
        })    
      } else {
        this.actionState.alert = { visible: true, text: 'Údaj na úpravu nemá správny formát.', variant: 'warning', icon: 'exclamation-circle-fill', retryLink: false } 
      }
      setTimeout(() => {
        window.parent.scrollBy({
          top: 120 - window.parent.scrollY,
          left: 0,
          behavior: "smooth"
        })
      }, 350);
    }      
    },
    htmlEscape: function (str) {
			return str.replace(/\&/g, '&amp;').replace(/\"/g, '&quot;').replace(/\'/g, '&#39;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;');
    },
    checkMailVal: function(userIn) {
      var ctrlRgx = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,14}))$/i;
      if ((ctrlRgx.test(userIn)) || (userIn.length === 0)) {
        return true;
      }
      else {
        return false;
      }
    },
    validateMsisdn: function(msisdn) {
      var res = true;
      msisdn = (String(msisdn || '')).replace(/ /g, '');
      if (msisdn.length < 9 || (msisdn.length === 9 && msisdn.slice(0,1) == '0') || isNaN(msisdn)) {
        res = false;
      }
      return res;
    }
  },
  computed: {
    srcMobilePhone: function() {
      if (this.verifData.data.mobilePhone) {
        var res = this.verifData.data.mobilePhone
        return res.toString().toLowerCase().replace(/ /g, '')
      } else {
        return ''
      }
    },
    srcEmail: function() {
      if (this.verifData.data.email) {
        var res = this.verifData.data.email
        return res.toLowerCase().replace(/ /g, '')
      } else {
        return ''
      }
    },
    srcMobilePhonePH: function() {
      if (this.srcMobilePhone != '') {
        return (this.srcMobilePhone).toString().toLowerCase().replace(/ /g, '')
      } else {
        return 'Nezadané'
      }
    },
    srcEmailPH: function() {
      if (this.srcEmail != '') {
        return this.srcEmail.toLowerCase().replace(/ /g, '')
      } else {
        return 'Nezadaná'
      }
    },
    sendText: function() {
      if (this.newData.checkOnly) {
        return 'Údaje sú správne'
      } else {
        return 'Uložiť zmeny'
      }
    }
  },
  watch: {
    newData: {
      handler: function (val, oldVal) {
        if ((String(this.verifData.data.idCard || '')).replace(/ /g, '').replace(/\//g, '') !== (String(val.idCard || '')).replace(/ /g, '').replace(/\//g, '')) {
          const validationObj = validatePersonalNr(this.newData.personalNr);
          if (!validationObj.res || validationObj.isEmpty) {
            let rText = 'Pre zmenu OP je tento údaj povinný';
            if (!validationObj.isEmpty) {
              rText = 'Rodné číslo nie je správne vyplnené';
            }
            this.errors.personalNr = { visible: true, text: rText }
            this.actionState.submitDisable = true;
          } else {
            this.errors.personalNr = { visible: false, text: '' }
            this.actionState.submitDisable = false;
          }
        } else {
          this.errors.personalNr = { visible: false, text: '' }
          this.actionState.submitDisable = false;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

.teldata, .maildata {
  width: 100%;
  background-color: #585858;
  color: #ffffff;
  padding: 5px 10px;
  border-radius: 4px;
}

.maildata {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.maildata p, .teldata p {
  font-weight: bold;
  margin: 10px 0 10px 0;
  font-size: 18px;
}

.result {
  width: 100%;
  text-align: center;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
}

input.invalid {
  border-width: 1px 4px;
  border-color: #e20074;
}

input.invalid:focus {
  border-color:#e20074;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

button.btn-success, button.btn-link {
    text-shadow: 0 0 #FFF;
    box-sizing: border-box;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    padding: 0 10px;
    display: inline-block;
    text-decoration: none;
    cursor: pointer;
    border-radius: 4px;    
}
button.btn.btn-primary span {
  color: #ffffff !important;
}
</style>
